export enum MessageStatus {
	SUCCESS = 'SUCCESS',
	ERROR = 'ERROR',
	INFO = 'INFO',
	WELCOME = 'WELCOME',
}

export enum MessageTitles {
	DONE = 'Done',
	ERROR = 'Error',
	INFO = '',
	WELCOME = 'Welcome to ProveraCare!',
}

export enum MessageDuration {
	DEFAULT = 3000,
	MEDIUM = 6000,
	LONG = 9000,
}

export interface Message {
	status: MessageStatus;
	title: String | MessageTitles;
	duration: MessageDuration;
	message: String;
}

const Message = {
	successMessage(
		message: String,
		duration = MessageDuration.DEFAULT,
		title: String | MessageTitles = MessageTitles.DONE
	): Message {
		return {
			status: MessageStatus.SUCCESS,
			title,
			duration,
			message,
		};
	},
	infoMessage(message: String, duration = MessageDuration.DEFAULT): Message {
		return {
			status: MessageStatus.INFO,
			title: MessageTitles.INFO,
			duration,
			message,
		};
	},
	welcomeOnboard(
		message: String,
		duration = MessageDuration.DEFAULT
	): Message {
		return {
			status: MessageStatus.WELCOME,
			title: MessageTitles.WELCOME,
			duration,
			message,
		};
	},
	errorMessage(message: String, duration = MessageDuration.DEFAULT): Message {
		return {
			status: MessageStatus.ERROR,
			title: MessageTitles.ERROR,
			duration,
			message,
		};
	},
};

export default Message;
